
import { Image } from "element-ui"
export default {
  components: {
    [Image.name]: Image
  },
  props: {
    count: {
      type: Number,
      default: 3
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    handleDelete(item, index) {
      this.$emit("delete", {
        skuId: item.skuId,
        index
      })
    },
    handleGoDetail(val) {
      this.$navigation.push(
        `${this.MAIN_ORIGIN}${this.MAIN_PATH}/p/${encodeURIComponent(val.wareName)}/i/${val.skuId}.html`
      )
    }
  }
}
